import TaskPlansSettingsView from "@/components/features/settings/defaults/matter-task-plans/TaskPlansSettingsView";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { INTAKE_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/intake/task-plans")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.intakeSettingsTaskPlans)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <TaskPlansSettingsView
      title="Task plans"
      addButtonLabel="Add intake task plan"
      statusCategories={INTAKE_STATUS_CATEGORY_OPTIONS}
    />
  );
}
